import React from 'react';

const ProductDetails = ({product}) => {

	const getDurationFormat = (duration) => {
		duration = duration / 60
		const minutes = duration % 60
		const hours = Math.floor(duration / 60)
		const result = []
		if (hours > 0){
			result.push(`${hours}h`)
			if(minutes > 0){
				result.push(`${minutes}`)
			}
		} else {
			result.push(`${minutes} min`)
		}
		return result.join('')
  	}

	const getMoney = (price) => {
		// Format price like 10,00 €
		price = price / 100
		return `${price.toFixed(2).replace('.', ',')} €`
	}

	if(!product) {
		return null;
	}

	return (
		<div className="widget_session_booking_product_content">
			<i className='hgi-stroke hgi-video-01'></i> 
			{getDurationFormat(product.duration)} <span>●</span> {getMoney(product.price)}
		</div>
	);
}

export default ProductDetails;